import {PageService, ProductService} from "@api";
import {SeoSchemaWebPage, type WebPageType} from "@/components/SeoSchema/mode/SeoSchemaWebPage";
import {getSiteUrl} from "@/helpers/functions";

export interface CmsWebPageSchemaProps {
    slug: string;
    path: string;
    pageType?: WebPageType;
    source?: "page" | "product";
    primaryImageUrl?: string;
    descriptionFallback?: string;
}

const stripHtml = (value: string): string =>
    value.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

export async function CmsWebPageSchema({
    slug,
    path,
    pageType = "WebPage",
    source = "page",
    primaryImageUrl,
    descriptionFallback,
}: CmsWebPageSchemaProps) {
    const siteUrl = getSiteUrl();
    const absoluteUrl = `${siteUrl}/${path.replace(/^\//, "")}`;

    let name: string | undefined;
    let description: string | undefined;
    let datePublished: string | undefined;
    let dateModified: string | undefined;

    if (source === "product") {
        const product = await ProductService.getBySlug(slug);
        if (!product) return null;
        name = product.seoTitle ?? product.title ?? slug;
        const cmsDesc = product.seoDescription ?? stripHtml(product.shortDescription ?? "");
        description = cmsDesc || descriptionFallback || `${name} — ACTIVE Vapor Devices.`;
        datePublished = product.createdAt;
        dateModified = product.updatedAt;
    } else {
        const page = await PageService.getBySlug(slug);
        if (!page) return null;
        name = page.seoTitle ?? page.title ?? slug;
        description = page.seoDescription ?? descriptionFallback ?? `${name} — ACTIVE Vapor Devices.`;
        datePublished = page.createdAt;
        dateModified = page.updatedAt;
    }

    return (
        <SeoSchemaWebPage
            pageType={pageType}
            url={absoluteUrl}
            name={name ?? slug}
            description={description ?? ""}
            datePublished={datePublished}
            dateModified={dateModified}
            primaryImageUrl={primaryImageUrl}
        />
    );
}
